<template>
  <div>

    <!-- 我听课/我讲课 -->
    <van-tabs v-model="active">
      <van-tab title="我听课">
        <Listening :dataList="itemList"
                   @getList="getList"
                   :totalRecords="liseTotalRecords"
                   :num="listNum"
                   :status="0"></Listening>
      </van-tab>

      <van-tab title="我讲课">
        <Listening :dataList="MyEvaDt"
                   @getCom="getCom"
                   :totalRecords='comTotalRecords'
                   :num="comNum"
                   :status="1"></Listening>
      </van-tab>
    </van-tabs>

  </div>
</template>

<script>
import Listening from './Listening';
export default {
  name: "Index",
  components: {
    Listening,
  },
  data () {
    return {
      active: 0,
      itemList: [],
      MyEvaDt: [],
      liseTotalRecords: 0,
      comTotalRecords: 0,
      listNum: 0,
      comNum: 0,
      status: 0,
    };
  },
  created () {
  },
  mounted () {
  },
  methods: {
    // 我听课
    async getList (index) {
      if (index === 1) this.itemList = []
      this.listNum = index
      let res = await this.xyapi.get(this.$store.state.apiPath + '/api/Evaluate/GetPageMyEvaluate', {
        PageIndex: index || 0,
        PageSize: 15,
        typeID: 2
      })
      if (res.success) {
        if (res.data.data && res.data.data.length > 0) {
          this.itemList = [...this.itemList, ...res.data.data]
          this.liseTotalRecords = res.data.totalRecords
        }
      }
    },
    // 我讲课
    async getCom (index) {
      if (index === 1) this.MyEvaDt = []
      this.comNum = index
      let res = await this.xyapi.get(this.$store.state.apiPath + '/api/Evaluate/GetPageMyEvaluate', {
        PageIndex: index || 0,
        PageSize: 15,
        typeID: 1
      })
      if (res.success) {
        if (res.data.data && res.data.data.length > 0) {
          this.comTotalRecords = res.data.totalRecords
          this.MyEvaDt = [...this.MyEvaDt, ...res.data.data]
        }
      }
    },
  }
};
</script>
<style lang='less' scope>
</style>